const PREVIEW_MAX_LENGTH = 120;

// Strips common markdown markers and truncates the result so a multi-line
// rich-text note can be shown as a single-line preview.
export const buildNotePreview = (content: string) => {
  const stripped = content
    .replace(/[#>*_`]/g, '')
    .replace(/^\s*[-+*]\s+/gm, '')
    .replace(/^\s*\d+\.\s+/gm, '')
    .replace(/\s+/g, ' ')
    .trim();
  return stripped.length > PREVIEW_MAX_LENGTH
    ? `${stripped.slice(0, PREVIEW_MAX_LENGTH)}…`
    : stripped;
};
